import { render, staticRenderFns } from "./PublicationCard.vue?vue&type=template&id=464f5fcc"
import script from "./PublicationCard.vue?vue&type=script&lang=js"
export * from "./PublicationCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports